import * as Yup from "yup";
import { CODE_2FA_DIGIT_ONLY_MSG, CODE_2FA_MIN_LENGTH_MSG, CODE_REQUIRED_2FA } from "../../constants/messages";
import { emailValidator } from "../../validations";
import { CODE_2FA_MIN_LENGTH } from "../../constants";

export const ForgotSchema = Yup.object({
    email: emailValidator,
    code: Yup.string().required(CODE_REQUIRED_2FA).matches(/^[0-9]+$/, CODE_2FA_DIGIT_ONLY_MSG).min(CODE_2FA_MIN_LENGTH, CODE_2FA_MIN_LENGTH_MSG).max(CODE_2FA_MIN_LENGTH, CODE_2FA_MIN_LENGTH_MSG)
});